// German money format: 1.234,50 €
export const formatEUR = (value) =>
  `${Number(value || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
